import React, { useState, useMemo } from "react";
import { Typography, FormHelperText } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

const CustomMonthYearPicker = ({
  sx,
  sxText,
  label,
  id,
  value,
  onDateChange,
  isMandatoryField = false,
  disabled,
  error,
  helperText,
  autoFocus = false,
  errorMessage,
  name,
  modal,
}) => {
  const [selectValue, setSelectValue] = useState(null);
  console.log("SelectValue", selectValue);
  
  const [open, setOpen] = useState(false);

  const mandatoryRequiredButton = useSelector(
    (state) => state.mandatoryFields.isMandatoryRequiredEnabled
  );
  const viewEnabled = useSelector(
    (state) => state.mandatoryFields.isViewEnabled
  );

  useMemo(() => {
    if (value) {
      const parsedDate = dayjs(value, "YYYY-MM");
      setSelectValue(parsedDate.isValid() ? parsedDate : null);
    } else {
      setSelectValue(null);
    }
  }, [value]);

  const handleDateChange = (date) => {
    setSelectValue(date);
    const formattedDate = date.format("YYYY-MM");
    onDateChange(formattedDate, name, isMandatoryField);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Typography variant="labelSm" color={"text.primary"} component={"label"}>
        {label}
        {isMandatoryField && (
          <Typography component={"span"} color={"error"}>
            *
          </Typography>
        )}
      </Typography>

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          views={["month", "year"]}
          autoFocus={autoFocus}
          onOpen={() => setOpen(true)}
          id={id}
          value={selectValue}
          open={open}
          onClose={handleClose}
          onChange={handleDateChange}
          sx={{
           ...sx
          }}
          name={name}
          disabled={
            viewEnabled ||
            (mandatoryRequiredButton && !isMandatoryField) ||
            disabled
          }
          slotProps={{
            textField: {
              helperText: helperText,
              error: error,
              readOnly: true,
              InputProps: {
                placeholder: disabled ? "" : "YYYY-MM",
                sx: {...sxText},
                value: selectValue ? selectValue.format("MMM YYYY") : "",
              },
              onClick: () => setOpen(true),
            },
            popper: {
              className: modal && "zIndex-1400",
            },
          }}
        />
      </LocalizationProvider>
      {error && (
        <FormHelperText sx={{ color: "red", borderColor: "red" }}>
          {errorMessage}
        </FormHelperText>
      )}
    </>
  );
};

export default CustomMonthYearPicker;
